export default __webpack_public_path__ + "static/media/Collision_experiments.07fe96dc.zip";